import FormField from 'lib/src/components/form/FormField';
import { FormInputProps } from 'lib/src/types/shared/FormInputProps';
import React from 'react';
import useFieldValidation from './hooks/useFieldValidation';

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    name,
    onChange,
    value,
    disabled,
    required,
    hideDisabled,
    label = '',
    showBlueLabel = false,
    customValidate,
    textColour = 'black',
}) => {
    const [error, _] = useFieldValidation({
        name,
        customValidate,
        value,
    });

    return (
        <>
            <FormField
                name={name}
                label={showBlueLabel && label ? label : ''}
                required={required}
                error={error}
                className={`checkbox ${disabled ? 'left grey-out' : ''} ${
                    hideDisabled && disabled ? 'hide' : ''
                }`}
            >
                <input
                    id={name}
                    onChange={handleChange}
                    type="checkbox"
                    checked={value}
                    name={name}
                    disabled={disabled}
                />
                <label htmlFor={name}>
                    {label.length && !showBlueLabel && (
                        <span className={`text ${textColour}`}>{label}</span>
                    )}
                    <span className="outer">
                        <span className="inner" />
                    </span>
                </label>
            </FormField>
        </>
    );

    function handleChange() {
        const newVal = !value;
        onChange(name, newVal);
    }
};

interface ToggleSwitchProps extends FormInputProps<boolean> {
    hideDisabled?: boolean;
    label?: string;
    textColour?: string;
    showBlueLabel?: boolean;
    required?: boolean;
}

export default ToggleSwitch;
